export default [
  {
    path: '/user',
    component: () => import('@/views/User.vue'),
    name: 'user',
    meta: {
      navName: 'user',
      sideNav: true,
      requiresAuth: true
    },
  },
  {
    path: '/user/new',
    component: () => import('@/views/User/New.vue'),
    name: 'user-new',
    meta: {
      navName: 'user',
      sideNav: true,
      requiresAuth: true
    }
  },
  {
    path: '/user/:id',
    component: () => import('@/views/User/Edit.vue'),
    name: 'user-edit',
    meta: {
      navName: 'user',
      sideNav: true,
      requiresAuth: true
    }
  },
  {
    path: '/user/:id/message/new',
    component: () => import('@/views/Message/New.vue'),
    name: 'user-message-new',
    meta: {
      navName: 'user',
      sideNav: true,
      requiresAuth: true
    }
  },
  {
    path: '/user/:id/bank',
    component: () => import('@/views/BankEdit.vue'),
    name: 'user-bank-edit',
    meta: {
      navName: 'user',
      sideNav: true,
      requiresAuth: true
    }
  }
]
